import Guest from 'components/Guest';
import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

// Account

const LoginBasic = Loader(lazy(() => import('content/pages/Auth/Login/Basic')));

const RegisterCover = Loader(
  lazy(() => import('content/pages/Auth/Register/Cover'))
);
const RegisterBasic = Loader(
  lazy(() => import('content/pages/Auth/Register/Basic'))
);
const RegisterWizard = Loader(
  lazy(() => import('content/pages/Auth/Register/Wizard'))
);

const RecoverPassword = Loader(
  lazy(() => import('content/pages/Auth/RecoverPassword'))
);

const ResetPassword = Loader(
  lazy(() => import('content/pages/Auth/RecoverPassword/ResetPassword'))
);

const accountRoutes = [
  // {
  //   path: 'login',
  //   element: (
  //     <Guest>
  //       <LoginCover />
  //     </Guest>
  //   )
  // },
  // {
  //   path: 'register',
  //   element: (
  //     <Guest>
  //       <RegisterCover />
  //     </Guest>
  //   )
  // },
  {
    path: 'reset-password',
    element: <ResetPassword />,
  },
  {
    path: 'login-basic',
    element: <LoginBasic />,
  },
  // {
  //   path: 'login-cover',
  //   element: <LoginCover />
  // },
  {
    path: 'recover-password',
    element: <RecoverPassword />,
  },
  {
    path: 'register',
    element: (
      <Guest>
        <RegisterCover />
      </Guest>
    ),
  },
  {
    path: 'register-basic',
    element: <RegisterBasic />,
  },
  {
    path: 'register-cover',
    element: <RegisterCover />,
  },
  {
    path: 'register-wizard',
    element: <RegisterWizard />,
  },
];

export default accountRoutes;
